module.exports = __webpack_public_path__ + "img/babylon.03435fbd.svg";